import Http from '@/utils/http/index';

export default {
  /**
   * 上传列表
   */
  getUploadList(params) {
    return Http.get('/merUploadCenter/queryUploads', { params });
  },
};
